module.exports = __webpack_public_path__ + "fonts/Roboto-SemiBoldItalic.600ae6c.woff2";